import { augmentTrackingHeaders, buildExecAppelRest, buildContext } from './chunk-JPNTSM5L.js';

// src/middlewares/axios.middleware.ts
function axiosInterceptorFactory(logger, customCtx) {
  function onRequest(request) {
    try {
      const config = logger.getConfig();
      request.headers = augmentTrackingHeaders(
        config.st,
        customCtx?.trackerIdProvider?.() ?? config.getTrackerId?.(),
        // @ts-expect-error request libs all provide different format for headers
        request.headers
      );
    } catch (error) {
      console.log("Erreur lors de l'ajout des headers de tra\xE7abilit\xE9", error);
    }
    return request;
  }
  function onResponseSuccess(response) {
    if (response.request.fromCache) ; else {
      _onResponse(response);
    }
    return response;
  }
  function onResponseError(error) {
    if (error.response) {
      _onResponse(error.response, error);
    } else if (!error.response && error.config) {
      _onResponse({ status: 500, config: error.config }, error);
    }
    throw error;
  }
  function _onResponse(response, error = null) {
    try {
      const currentTime = Date.now();
      const config = logger.getConfig();
      const axiosConfig = response?.config || error?.config;
      let parsedData;
      try {
        parsedData = JSON.parse(axiosConfig.data);
      } catch {
        parsedData = axiosConfig.data;
      }
      const execAppelRest = buildExecAppelRest(
        config,
        currentTime,
        axiosConfig.headers,
        axiosConfig.url,
        axiosConfig.method,
        parsedData,
        response.status,
        buildAxiosError(error)
      );
      const ctx = buildContext(config, {
        headers: axiosConfig.headers,
        userInfoProvider: customCtx?.userInfoProvider
      });
      logger.getTransporter().push({
        ctx,
        events: [execAppelRest]
      });
    } catch (error2) {
      console.error("Erreur lors de l'envoie des logs de l'appel Rest", error2);
    }
  }
  function buildAxiosError(error) {
    if (error == null) {
      return void 0;
    }
    const parameters = error.response?.data?.error_parameters;
    const parametersList = typeof parameters === "string" ? [parameters] : parameters;
    return {
      code: error.code || "ERREUR_APPEL_RESS",
      type: error.response?.status && error.response?.status >= 400 && error.response?.status < 500 ? "FONCTIONNELLE" : "TECHNIQUE",
      // @ts-expect-error skip full verification for error object
      description: error.response?.data?.error_description || error.message,
      parametres: parametersList,
      criticite: error.response?.status && [502, 503, 504].includes(error.response?.status) ? "INDISPO" : "FATALE"
    };
  }
  return {
    onResponseError,
    onRequest,
    onResponseSuccess
  };
}
function wrapAxiosInstanceWithLogger(axiosInstance, logger, customCtx) {
  const axiosInterceptors = axiosInterceptorFactory(logger, customCtx);
  axiosInstance.interceptors.request.use(axiosInterceptors.onRequest);
  axiosInstance.interceptors.response.use(
    axiosInterceptors.onResponseSuccess,
    axiosInterceptors.onResponseError
  );
}

export { axiosInterceptorFactory, wrapAxiosInstanceWithLogger };
//# sourceMappingURL=chunk-QX4VQSB3.js.map
//# sourceMappingURL=chunk-QX4VQSB3.js.map